import React from 'react';
import { Clock, Calendar, PlayCircle, StopCircle, PlusCircle } from 'lucide-react';
import { format } from 'date-fns';

interface TimeEntry {
  id: string;
  date: string;
  jobName: string;
  startTime: string;
  endTime: string;
  breakDuration: number;
  status: 'in_progress' | 'completed' | 'pending_approval';
  totalHours: number;
}

const mockTimeEntries: TimeEntry[] = [
  {
    id: '1',
    date: '2024-03-18',
    jobName: 'Kitchen Renovation - Sarah Johnson',
    startTime: '07:30',
    endTime: '16:00',
    breakDuration: 30,
    status: 'completed',
    totalHours: 8,
  },
  {
    id: '2',
    date: '2024-03-18',
    jobName: 'Bathroom Plumbing - Mike Smith',
    startTime: '09:00',
    endTime: '',
    breakDuration: 0,
    status: 'in_progress',
    totalHours: 0,
  },
];

export function TimeSheets() {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-900">Time Sheets</h2>
          <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors flex items-center gap-2">
            <PlusCircle className="h-4 w-4" />
            New Entry
          </button>
        </div>
      </div>
      <div className="p-6">
        <div className="space-y-4">
          {mockTimeEntries.map(entry => (
            <div key={entry.id} className="border rounded-lg p-4 hover:bg-gray-50">
              <div className="flex justify-between items-start">
                <div>
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4 text-gray-400" />
                    <span className="text-sm text-gray-500">
                      {format(new Date(entry.date), 'EEEE, MMMM d, yyyy')}
                    </span>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mt-1">{entry.jobName}</h3>
                </div>
                <span
                  className={`px-2 py-1 text-xs font-semibold rounded-full
                  ${entry.status === 'completed' ? 'bg-green-100 text-green-800' : ''}
                  ${entry.status === 'in_progress' ? 'bg-blue-100 text-blue-800' : ''}
                  ${entry.status === 'pending_approval' ? 'bg-yellow-100 text-yellow-800' : ''}
                `}
                >
                  {entry.status.replace('_', ' ').charAt(0).toUpperCase() + entry.status.slice(1)}
                </span>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-4">
                <div className="flex items-center gap-2">
                  <Clock className="h-4 w-4 text-gray-400" />
                  <span className="text-sm text-gray-600">
                    {entry.startTime} - {entry.endTime || 'In Progress'}
                  </span>
                </div>
                <div className="flex items-center gap-2 justify-end">
                  {entry.status === 'in_progress' ? (
                    <button className="flex items-center gap-1 text-red-600 hover:text-red-700">
                      <StopCircle className="h-4 w-4" />
                      Stop Timer
                    </button>
                  ) : (
                    <span className="text-sm text-gray-600">
                      Total: {entry.totalHours} hours
                      {entry.breakDuration > 0 && ` (${entry.breakDuration}min break)`}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
